import { AxiosResponse } from 'axios';
import axios from './AxiosService';

export default {
  /**
   * Fetches parking zone data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  fetchParkingZones(): Promise<AxiosResponse> {
    return axios.get('/parkingZones');
  },
  /**
   * Fetches parking spot data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  fetchParkings(): Promise<AxiosResponse> {
    return axios.get('/parkings');
  },
  /**
   * Fetches parking meter data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  fetchParkingMeters(): Promise<AxiosResponse> {
    return axios.get('/parkingMeters');
  },
  /**
   * Fetches parking spots data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  fetchParkingSpots(): Promise<AxiosResponse> {
    return axios.get('/parkingSpots');
  },
  /**
   * Fetches parking groups data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  fetchParkingGroups(): Promise<AxiosResponse> {
    return axios.get('/parkingGroups');
  },
  /**
   * Fetches settings data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  fetchEvents(): Promise<AxiosResponse> {
    return axios.get('/events');
  },
  /**
   * Fetches settings data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  fetchWeatherStations(): Promise<AxiosResponse> {
    return axios.get('/weatherStations');
  },
  /**
   * Fetches settings data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  fetchCurrentWeather(): Promise<AxiosResponse> {
    return axios.get('/weatherStations/average');
  },
  /**
   * Fetches settings data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  fetchSettings(): Promise<AxiosResponse> {
    return axios.get('/settings');
  },
  /**
   * Fetches pages data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  fetchPosts(): Promise<AxiosResponse> {
    return axios.get('/posts');
  },
  /**
   * Fetches pages data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  fetchPostDetails(id: number): Promise<AxiosResponse> {
    return axios.get(`/posts/${id}`);
  },
};
